import { Modal, Tabs } from 'antd'
import ReadyToOrderForm from '../../../components/Purchasing/Order/ReadyToOrderForm'
import ReadyToOrderFreightForm from '../../../components/Purchasing/Order/ReadyToOrderFreightForm'
import StockReleaseOrderForm from '../../../components/Purchasing/Order/StockReleaseOrderForm'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import _ from 'lodash'
import React from 'react'
import Switch, { Case, Default } from 'react-switch-case'

const { TabPane } = Tabs

function OrderModal(props) {
  const {
    visible,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    order,
    isNew,
    selectionData,
  } = props

  const type = _.get(order, 'category') || _.get(selectionData, '[0].type')
  // const isFreight = ['Freight', 'Clearance'].includes(type)

  return (
    <Modal
      visible={visible}
      title={'Ready To Order'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Ready To Order'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Tabs defaultActiveKey="form">
        <TabPane tab="Form" key="form">
          <Switch condition={type}>
            <Case value="Stock Release Order">
              <StockReleaseOrderForm ref={formRef} {...props} />
            </Case>
            <Case value="Freight">
              <ReadyToOrderFreightForm ref={formRef} {...props} />
            </Case>
            <Case value="Clearance">
              <ReadyToOrderFreightForm ref={formRef} {...props} />
            </Case>
            <Default>
              <ReadyToOrderForm ref={formRef} {...props} />
            </Default>
          </Switch>
        </TabPane>

        <TabPane disabled={true} tab="Fee" key="fee" />
        <TabPane disabled={true} tab="Packing List" key="freight" />
        <TabPane disabled={true} tab="Files" key="files" />
      </Tabs>
    </Modal>
  )
}

export default OrderModal
